import { createFileRoute, useRouter } from '@tanstack/react-router';

import { Button } from '@apps/web/components/ui/button';
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from '@apps/web/components/ui/card';

// Where a customer lands after confirming their intro call on Calendly
// (DEP-324). Calendly's per-event-type "redirect to an external site" points
// here, so this page has to hold every post-booking arrival: a just-signed
// customer who has not set a password yet, and a returning one who already
// has. It never dead-ends either. The only action sends them to
// `/reset-password`, the DEP-303 setup entry, which self-heals for both: a
// signed-in visitor is bounced straight to the app, and a password-less one
// gets a fresh one-time setup code. Landing on Calendly's default confirmation
// page instead would strand a brand-new signer with no obvious next step.
export const Route = createFileRoute('/_auth/intro-call-booked')({
    head: () => ({
        meta: [
            {
                title: 'Intro call booked | Phoebe',
            },
        ],
    }),
    component: IntroCallBookedPage,
});

export function IntroCallBookedPage() {
    const router = useRouter();
    return (
        <Card className="w-full max-w-md">
            <CardHeader>
                <CardTitle>Your intro call is booked</CardTitle>
                <CardDescription>
                    Check your email for the calendar invite. Next, finish
                    setting up your Phoebe account so everything is ready for
                    your call.
                </CardDescription>
            </CardHeader>
            <CardContent>
                <p className="text-muted-foreground text-sm">
                    Setting up takes about a minute. If you have not set a
                    password yet, we will email you a one-time code to get
                    started.
                </p>
            </CardContent>
            <CardFooter>
                <Button
                    className="w-full"
                    onClick={() => router.navigate({ to: '/reset-password' })}
                >
                    Finish setting up my account
                </Button>
            </CardFooter>
        </Card>
    );
}
